export default __webpack_public_path__ + "static/media/bg.38d4abbb.png";